import { useEffect, useState } from "react";
import { Button, Label, Loader } from "semantic-ui-react";
import styles from "./styles.module.css";
import "./styles.module.css";
import { ErrorMessage, Form, Formik } from "formik";
import { InputTemp, SelectTemp } from "../../../../../app/common/form/Custom";
import { authSchema } from "../../../../../app/validation/validationSchema";
import Modal from "../../../../../app/common/modals/Custom";
import { useNavigate } from "react-router-dom";
import { ReactComponent as PlaySvg } from "../../../../../assets/play.svg";
import { useStore } from "../../../../../app/stores/store";
import { ReactComponent as SuccessCircleSvg } from "../../../../../assets/SuccessCircle.svg";
import { observer } from "mobx-react-lite";
import Loading from "../../../../../app/layout/Loading";
import { toast } from "react-toastify";
import { handlePhoneNumber } from "../../../../../app/common/hooks/helpers";

const PersonalInfo = (props: any) => {
  const { inputField, setInputField, handleChange, scoreField } = props;
  const [options, setOptions] = useState<any[]>([]);
  const [pV, setPV] = useState(false);
  const [cPV, setCPV] = useState(false);
  const { userStore } = useStore();
  const {
    register,
    userProductCategories,
    getCategories,
    getStates,
    registerIsSuccess,
    setRegisterIsSuccess,
    status,
    logout,
    accountVerification,
  } = userStore;
  const [modal, setModal] = useState("");
  const navigate = useNavigate();

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    address: "",
    state: "",
    city: "",
    phoneNumber: "",
    saFcurrentAccount: "",
    businessName: "",
    // accountName: "",
    categoryOfProduct: "",
    referral_Code : ""
  };
  const safAccountUrl = process.env.REACT_APP_NEWTABACCOUNT_URL;
  const accountType = process.env.REACT_APP_ACCOUNTTYPE;
  const handleInputAccountVerification = async (
    value: string,
    setFieldValue: any
  ) => {
    accountVerification(value)
      .then((res) => {
        // console.log(res);
        if (String(res.data.getAccounts.accounT_CLASS).toLowerCase().includes(String(accountType).toLowerCase())){
          setFieldValue("businessName", res.data.getAccounts.acC_NAME);
          setInputField({
            ...inputField,
            businessName: res.data.getAccounts.acC_NAME,
          });
        } else {
          setFieldValue("businessName", "");
          setInputField({
            ...inputField,
            businessName: "",
          });
          toast.error("Invalid Current Account");
        }
      })
      .catch((err) => console.log(err));
  };
  const getFormCategories = (
    list: { key: string; label: string; value: string }[]
  ) => {
    let payloadCategories: string[] = [];
    for (let i = 0; i < list.length; i++) {
      payloadCategories.push(list[i].value);
    }
    return payloadCategories;
  };
  // const loc = getLocations(values.productLocations);
  useEffect(() => {
    getCategories();
    // .catch();
  }, [getCategories]);
  return (
    <>
      {status === "loading" && <Loading />}
      {registerIsSuccess && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => {
            if (registerIsSuccess === "success") {
              setRegisterIsSuccess("");
              setModal("");
              navigate("/login");
            } else {
              setRegisterIsSuccess("");
              setModal("");
            }
          }}
        >
          <div className={styles.verifyAccountModal}>
            {registerIsSuccess === "success" ? (
              <h2>Complete Registration</h2>
            ) : (
              <h2>Account Verification</h2>
            )}
            {registerIsSuccess === "success" && (
              <div className={styles.welcomeText}>
                <p>Thank you for registering with us. ⭐️</p>
              </div>
            )}

            {registerIsSuccess === "success" && (
              <div className={styles.info}>
                <div>
                  Please check your email for a verification link to verify your
                  account
                </div>
              </div>
            )}
            {registerIsSuccess === "loading" && (
              <div className={styles.info}>
                <div>
                  Please wait while we verify your ALTERNATIVE BANK Current
                  account number.
                </div>
              </div>
            )}

            {registerIsSuccess === "loading" && (
              <div
                className={styles.loader}
                // style={{ marginTop: "20px", marginBottom: "50px" }}
              >
                {" "}
                <Loader active size="huge"></Loader>
              </div>
            )}
            {registerIsSuccess === "success" && (
              <div className={styles.successCircle}>
                <SuccessCircleSvg />
              </div>
            )}

            {registerIsSuccess === "success" && (
              <div className={styles.btnCancel}>
                <Button
                  // negative
                  className={styles.negative}
                  onClick={() => {
                    setRegisterIsSuccess("");
                    logout();
                    navigate("/login");
                  }}
                >
                  <span>Cancel</span>
                </Button>
              </div>
            )}
          </div>
        </Modal>
      )}

      <div className={styles.header}>Personal Information</div>
      <div className={styles.required}>* All fields are required except from Referral Code.</div>
      <Formik
        initialValues={initialValues}
        // enableReinitialize
        onSubmit={() =>
          register({ ...inputField, ...scoreField }).catch((error) =>
            console.log(error)
          )
        }
        validationSchema={authSchema.register}
      >
        {({
          dirty,
          getFieldProps,
          handleSubmit,
          setFieldValue,
          isValid,
          errors,
          values,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <div className={styles.flexForm}>
                <div className={styles.marginRight}>
                  <InputTemp
                    inputType="text"
                    labelStyle={{ fontFamily: "Montserrat", color: "#828282" }}
                    label={"Enter Firstname"}
                    placeholder={"e.g John"}
                    marginRight
                    {...getFieldProps("firstName")}
                    onChange={(e) => {
                      setFieldValue("firstName", e.target.value);
                      handleChange(e);
                    }}
                  />
                  <ErrorMessage
                    name={"firstName"}
                    render={(error) => (
                      <Label basic color="red" content={error} />
                    )}
                  />
                </div>
                <div className={styles.marginLeft}>
                  <InputTemp
                    inputType="text"
                    labelStyle={{ fontFamily: "Montserrat", color: "#828282" }}
                    label={"Enter Lastname"}
                    placeholder={"e.g John"}
                    marginRight
                    {...getFieldProps("lastName")}
                    onChange={(e) => {
                      setFieldValue("lastName", e.target.value);
                      handleChange(e);
                    }}
                  />
                  <ErrorMessage
                    name={"lastName"}
                    render={(error) => (
                      <Label basic color="red" content={error} />
                    )}
                  />
                </div>
              </div>
              <div className={styles.flexForm}>
                <div className={styles.marginRight}>
                  <InputTemp
                    inputType="text"
                    labelStyle={{ fontFamily: "Montserrat", color: "#828282" }}
                    label={"Email Address"}
                    placeholder={"e.g user@gmail.com"}
                    marginRight
                    {...getFieldProps("email")}
                    onChange={(e) => {
                      setFieldValue("email", e.target.value);
                      handleChange(e);
                    }}
                  />
                  <ErrorMessage
                    name={"email"}
                    render={(error) => (
                      <Label basic color="red" content={error} />
                    )}
                  />
                </div>
                <div className={styles.marginLeft}>
                  <InputTemp
                    inputType="text"
                    labelStyle={{ fontFamily: "Montserrat", color: "#828282" }}
                    label={"Mobile Number"}
                    placeholder={"e.g 08010000002"}
                    marginRight
                    {...getFieldProps("phoneNumber")}
                    onChange={(e) => {
                      setFieldValue("phoneNumber", e.target.value);
                      handlePhoneNumber(setFieldValue, "phoneNumber", e)
                      handleChange(e);
                    }}
                  />
                  {errors.phoneNumber && values.phoneNumber ? (
                    <Label basic color="red" content={errors.phoneNumber} />
                  ) : null}
                </div>
              </div>

              <div className={styles.flexForm}>
                <div>
                  <SelectTemp
                    inputType="text"
                    // style={{ height: "38px" }}
                    label="Category of Product"
                    placeholder={"Select Category"}
                    options={
                      userProductCategories.length > 0
                        ? [...userProductCategories]
                            .sort(function (x, y) {
                              let a = x.category.toUpperCase(),
                                b = y.category.toUpperCase();
                              return a === b ? 0 : a > b ? 1 : -1;
                            })
                            .map((category, index) => ({
                              key: String(index),
                              label: category.category,
                              value: category.categoryId,
                            }))
                        : []
                    }
                    closeMenuOnSelect={false}
                    isMulti={true}
                    onValueChange={(e: any) => {
                      setFieldValue("categoryOfProduct", e);
                      setInputField({
                        ...inputField,
                        categoryOfProduct: getFormCategories(e),
                      });
                    }}
                    name="categoryOfProduct"
                  />
                  <ErrorMessage
                    name={"categoryOfProduct"}
                    render={(error) => (
                      <Label basic color="red" content={error} />
                    )}
                  />
                </div>
              </div>
              <div>
                <div>
                  <InputTemp
                    inputType="number"
                    labelStyle={{
                      fontFamily: "Montserrat",
                      color: "#828282",
                      fontSize: "12px",
                      paddingTop: "10px",
                    }}
                    label={"The Alternative Bank Current Account No."}
                    placeholder={"067926262"}
                    marginRight
                    {...getFieldProps("saFcurrentAccount")}
                    onChange={(e) => (
                      e.target.value.length === 10
                        ? (setFieldValue("saFcurrentAccount", e.target.value),
                          handleInputAccountVerification(
                            e.target.value,
                            setFieldValue
                          ))
                        : setFieldValue("saFcurrentAccount", e.target.value),
                      handleChange(e)
                    )}
                  />
                  <ErrorMessage
                    name={"saFcurrentAccount"}
                    render={(error) => (
                      <Label basic color="red" content={error} />
                    )}
                  />
                </div>
                <div></div>
              </div>
              <div>
                <div>
                  <InputTemp
                    inputType="text"
                    labelStyle={{
                      fontFamily: "Montserrat",
                      color: "#828282",
                      fontSize: "12px",
                      paddingTop: "10px",
                    }}
                    label={"Business name"}
                    placeholder={"e.g Alt Solar"}
                    marginRight
                    {...getFieldProps("businessName")}
                    disabled
                    // onChange={(e) => {
                    //   setFieldValue("businessName", e.target.value);
                    //   handleChange(e);
                    // }}
                  />
                  <ErrorMessage
                    name={"businessName"}
                    render={(error) => (
                      <Label basic color="red" content={error} />
                    )}
                  />
                </div>
                  
                <div>
                  <InputTemp
                    inputType="text"
                    labelStyle={{ fontFamily: "Montserrat", color: "#828282", fontSize: "12px",
                      paddingTop: "10px", }}
                    label={"Enter Referral Code"}
                    placeholder={"Referral Code"}
                    marginRight
                    {...getFieldProps("referral_Code")}
                    onChange={(e) => {
                      setFieldValue("referral_Code", e.target.value);
                      handleChange(e);
                    }}
                  />
                  <ErrorMessage
                    name={"referral_Code"}
                    render={(error) => (
                      <Label basic color="red" content={error} />
                    )}
                  />
                </div>
               
                <div></div>
              </div>

              <div className={styles.safInfo}>
                You can open an Alternative Bank account online and get your
                Account number in 5 minutes.{" "}
                <span
                  className={styles.sterlinks}
                  onClick={() => window.open(safAccountUrl, "_blank")}
                >
                  Click HERE
                </span>
              </div>
              <div className={styles.next}>
                <Button
                  positive
                  className={styles.positive}
                  type="submit"
                  disabled={!dirty || !isValid}
                  loading={registerIsSuccess === "loading"}
                  // onClick={() => nextStep()}
                >
                  <div className={styles.button}>
                    <span>Complete Registration</span>
                    <PlaySvg />
                  </div>
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default observer(PersonalInfo);
